// extracted by mini-css-extract-plugin
export default {"inputDate":"Complex_inputDate__3wfxK","flex1":"Complex_flex1__2k3YR","flex2":"Complex_flex2__SIsZp"};